import settings from '/@/core/settings';
import { getAppInstance, getSessionLanguage } from '/@/store/session/selectors';
import { createAction } from '/@/store/utils';
import { axFetch } from '../../session/actions';

export const downloadBagQualityPDF = createAction('BAG_QUALITY_PDFS:DOWNLOAD', async ({ payload, getState }) => {
    const state = getState();
    const response = await axFetch.post(settings.urls.bagQuality.pdfLink, {
        async: payload.download ? 'false' : 'true',
        appInstance: getAppInstance(state).id,
        language: getSessionLanguage(state),
        payload: payload.bagQuality,
    });

    return response.data;
});

export const emailBagQualityPDF = createAction('BAG_QUALITY_PDFS:EMAIL', async ({ payload, getState }) => {
    const state = getState();
    const response = await axFetch.post(settings.urls.bagQuality.pdfLink, {
        payload: payload.bagQuality,
        recipient: payload.email,
        appInstance: getAppInstance(state).id,
        language: getSessionLanguage(state),
    });

    if (response.status === 200) {
        return response.data;
    }
    throw Error();
});
